<template>
    <NewCourseSlot>
        <div id="LearningMyNewPlatformPreview">
            <div class="preview-page">
                <v-button
                    custom-type="text"
                    custom-style="secondary"
                    @click="$router.go(-1)"
                    style="margin-bottom: 40px;"
                >
                    <div style="display: flex; align-items: center">
                        <v-icon src="back" />
                        <span class="bottom__inner" style="color: #1D2228">Назад</span>
                    </div>
                </v-button>
                <h2 class="preview-page-header">{{ previewData.title }}</h2>

                <template v-for="(block, id) in previewData.contents">
                    <div v-if="block.content_type === 'html'" class="preview-page-block" :key="id">
                        <div v-html="block.content_object.html"></div>
                    </div>

                    <div v-else-if="block.content_type === 'video'" class="preview-page-block" :key="id">
                        <div class="preview-page-video">
                            <div class="preview-page-video-header">{{ block.content_object.title }}</div>
                            <video
                                :poster="block.content_object.video.url"
                                :src="block.content_object.video.url"
                                controls
                                class="preview-page-video-video"
                            />
                        </div>
                    </div>

                    <div v-else-if="block.content_type === 'embed'" class="preview-page-block" :key="id">
                        <div class="preview-page-video">
                            <div class="preview-page-video-header">{{ block.content_object.title }}</div>
                            <div class="thumb-wrap">
                                <iframe
                                    id="myiFrame"
                                    :src="calcEmbedUrl(block.content_object)"
                                    frameborder="0"
                                    allowfullscreen="allowfullscreen"
                                />
                            </div>
                        </div>
                    </div>

                    <div v-else-if="block.content_type === 'image'" class="preview-page-block" :key="id">
                        <div class="preview-page-video-header">{{ block.content_object.title }}</div>
                        <div class="preview-page-video">
                            <img v-show="block.content_object.image.url" :src="block.content_object.image.url" alt="" />
                        </div>
                    </div>
                </template>

                <div v-if="previewData.finish">
                    <div class="preview-page-bottom-block" v-if="previewData.finish.type === 'button'">
                        <v-button style="height: 48px;" class="desktop">
                            {{
                                previewData.finish.data.title
                                    ? previewData.finish.data.title
                                    : "Кнопка завершения урока"
                            }}
                        </v-button>
                    </div>
                    <div class="preview-page-bottom-block" v-if="previewData.finish.type === 'code'">
                        <v-input
                            name="telegram.login"
                            title="Завершение урока"
                            rules="required"
                            v-model="previewData.finish.code"
                            counter
                            :max="10"
                        />

                        <v-button style="height: 40px; margin-left: 8px; padding: 10px 32px" class="desktop">
                            Завершить
                        </v-button>
                    </div>
                    <div class="preview-page-bottom-block" v-if="previewData.finish.type === 'test'">
                        <v-button style="height: 48px" class="desktop">
                            Пройти тест
                        </v-button>
                    </div>
                </div>
            </div>
        </div>
    </NewCourseSlot>
</template>

<script>
import urlParser from "js-video-url-parser/lib/base";
import VButton from "../../../../../../common/components/VButton";

export default {
    name: "LessonPreview",
    props: {
        id: {},
        sectionId: {},
        lessonId: {},
        learningPlan: {}
    },
    components: {
        VButton,
        NewCourseSlot: () => import("../../../../builder/platform-new/NewCourseSlot")
    },
    data() {
        return {
            previewData: null
        };
    },
    created() {
        this.previewData = this.learningPlan
            .find(s => +s.id === +this.sectionId)
            .lessons.find(l => +l.id === +this.lessonId);
        /*    this.learningPlan[sectionIndex].lessons.find(l => +l.id === +this.lessonId);
           this.previewData = this.$store.getters["education/LEARNING_LESSON"];*/
    },
    methods: {
        routeBack() {
            this.$router.replace({ name: "editor-plan-lesson" });
        },
        calcEmbedUrl(data) {
            return urlParser.create({
                videoInfo: {
                    provider: data.type,
                    id: data.code,
                    mediaType: "video"
                },
                format: "embed"
            });
        },
        calcStyle(size) {
            if (size === "full") {
                return "width: 100%";
            } else {
                return `width: ${size}`;
            }
        }
    }
};
</script>

<style lang="scss">
#LearningMyNewPlatformPreview {
    max-width: 916px;
    width: 100%;
    margin: 0 auto;
    padding-top: 10px;
    @media (max-width: 630px) {
        width: 100%;
    }
    .thumb-wrap {
        position: relative;
        padding-bottom: 56.25%; /* задаёт высоту контейнера для 16:9 (если 4:3 — поставьте 75%) */
        height: 0;
        overflow: hidden;
    }
    .thumb-wrap iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-width: 0;
        outline-width: 0;
    }
    svg {
        fill: #8e99ab;
        margin-right: 10px;
        font-size: 22px;
    }

    .preview-page {
        &-bottom-block {
            display: flex;
            align-items: flex-end;
        }

        &-header {
            margin-bottom: 22px;
            font-family: "Roboto", sans-serif;
            font-weight: 500;
            font-size: 44px;
            line-height: 44px;
            color: #1d2228;
        }

        .preview-page-block {
            margin-bottom: 64px;
            p,
            li {
                margin-bottom: 5px;
                font-family: "Roboto", sans-serif;
                font-size: 20px;
                line-height: 32px;
                color: #1d2228;
            }
        }

        .preview-page-video {
            &-header {
                font-family: "Roboto", sans-serif;
                font-weight: bold;
                font-size: 28px;
                line-height: 40px;
                color: #1d2228;
                margin-bottom: 24px;
            }

            &-video {
                width: 100%;
            }
        }

        video,
        img {
            border-radius: 8px;
        }
    }
}
</style>
